	import { BaseTLDetailComponent, Component, GroupService, AxiosResponse } from "../../../Infrastructure/CorBase/CoreBase";
//	import { Component, Watch } from "../../../Infrastructure/CorBase/CoreBase";
	import store from '../../../Infrastructure/CorBase/StoreBase';



	export default abstract class GroupDetailBase extends BaseTLDetailComponent {

		formData = {
			id: 0,
			idTenant: store.state.idTenant,
			idGroup: null,
			idGroupText: '',
			name: '',
			description: '',
			setRightsByParentGroup: true as boolean,
			isEditable: true as boolean
		};

		groupService: GroupService = new GroupService();
		onlyShowIdGroup: boolean = false;
		returnRoute: string = "GroupList";


		///hlaska o prekroceni inputu po Ctrl+V
		protected infoShortInputBase(maxLength: string): void {
			this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
		}

		protected showDeleteButtonChild(): boolean {
			return this.showDeleteButton && this.formData.isEditable;
		}

		protected showEditButtonChild(): boolean {
			return this.showEditButton && this.formData.isEditable;
		}

		private superiorText(): string {
			var e = (document.getElementById("idGroup")) as HTMLSelectElement;
			if (e.selectedOptions[0] == undefined) {
				return 'nic';
			}
			return  e.selectedOptions[0].innerText;
		}


		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.groupService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
            this.formData.id = response.data.id;
            this.formData.idTenant = response.data.idTenant;
            this.formData.idGroup = response.data.idGroup;
            this.formData.idGroupText = response.data.idGroupText;
            this.formData.name = response.data.name;
            this.formData.description = response.data.description;
            this.formData.isEditable = response.data.isEditableRow;
        }

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.idGroupText = response.data.idGroupText;
		}

		doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('group.messageNew').toString(), this.$t('group.messageEdit').toString(), this.$t('group.messageDelete').toString());
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			this.formData.idGroup = this.formData.idGroup == '-1' ? null : this.formData.idGroup;
			this.formData.idGroupText = this.superiorText();
			return this.groupService.update(this.objectId, this.formData)
		}

		protected createObject(): Promise<AxiosResponse<any>> {
			this.formData.idTenant = Number(this.formData.idTenant);
			return this.groupService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.groupService.delete(this.objectId);
		}

		get showSaveButtonChild(): boolean {
			return this.formData.isEditable && this.showSaveButton;
		}

		//VaP - checkbox na nastaveni prav podle nadrazene skupiny zobrazime pouze pri vytvareni
		showSetRightsByParentGroup() {
			return !this.onlyShow && this.styleFormNew;
		}

		isOnlyShowIdGroup() {
			return this.onlyShowIdGroup || this.onlyShow;
		}

		vName: boolean = true;
		vDescription: boolean = true;
		vGroup: boolean = true;

		protected validateBase() {
			return !(this.vName
				&& this.vDescription
				&& this.vGroup
			);
		}

		protected isCorrectNameBase(value: any) {
			this.vName = value;
		}

		protected isCorrectDescriptionBase(value: any) {
			this.vDescription = value;
		}

		protected isCorrectGroupBase(value: any) {
			this.vGroup = value;
		}

		protected changeFieldsAfterChangeLanguageBase(value: boolean, oldValue: boolean) {
			if (value !== oldValue) {
				this.fetchData();
			}
		}

	}



